(() => {
  const selector = '.gt-featured-collection__list[data-gt-touch-slider]';
  const initializedAttribute = 'data-gt-touch-ready';

  function initTouchSlider(slider) {
    if (!slider || slider.hasAttribute(initializedAttribute)) return;

    slider.setAttribute(initializedAttribute, 'true');
    slider.querySelectorAll('img, a').forEach((element) => {
      element.setAttribute('draggable', 'false');
    });

    slider.addEventListener(
      'touchstart',
      () => {
        slider.classList.remove('is-horizontal-swiping');
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      () => {
        slider.classList.add('is-horizontal-swiping');
      },
      { passive: true }
    );

    const stopTracking = () => {
      window.setTimeout(() => slider.classList.remove('is-horizontal-swiping'), 120);
    };

    slider.addEventListener('touchend', stopTracking, { passive: true });
    slider.addEventListener('touchcancel', stopTracking, { passive: true });
    slider.addEventListener('dragstart', (event) => event.preventDefault());
  }

  function initAll(root = document) {
    root.querySelectorAll(selector).forEach(initTouchSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
